<div class="project-valuation-host">
  <ng-container>
    <side-bar-navigation class="side-bar-navigation"></side-bar-navigation>
    <div id="projectValuationModule" class="areaModuleContainer">
      <div class="areaModuleContainerInner">
        <div class="vpSearchForm" id="project-valuation-searchbar" [style.width.px]="paneWidths.get('#project-valuation-searchbar')" *ngIf="showSearchBar">
          <projects-search-form *ngIf="searchTabVisible && searchTab === 'projectstd'"></projects-search-form>
          <portfolios-search-form *ngIf="searchTabVisible && searchTab === 'valuationPortfolio'" [selectedItem]="selectedTabHierarchyItem" [selectedItemType]="selectedTabHierarchyItemType"></portfolios-search-form>
          <reports-search-form *ngIf="searchTabVisible && searchTab === 'report'" [selectedItem]="selectedTabHierarchyItem" [selectedItemType]="selectedTabHierarchyItemType"></reports-search-form>
        </div>
        <div class="polluxPane polluxWorkplacePane">
          <project-valuation-workplace [main]="this" class="pollux-workplace"></project-valuation-workplace>
        </div>
        <div id="project-valuation-infobar" class="infobar" [style.width.px]="(infoBarVisibility ? paneWidths.get('#project-valuation-infobar'):0)" [hidden]="!infoBarVisibility">
          <project-valuation-infobar [main]="this"></project-valuation-infobar>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Load module-wide dialogs etc-->
  <participants-assignment *ngIf="showParticipantsAssignment"></participants-assignment>
  <raci-host *ngIf="showRaciModule"></raci-host>
  <data-loader></data-loader>

  <!-- Dialogs -->
  <app-confirm-dialog></app-confirm-dialog>
  <confirm-delete-dialog></confirm-delete-dialog>
  <app-publish-validation-dialog></app-publish-validation-dialog>
  <app-publish-dialog></app-publish-dialog>
  <copy-valuation-portfolio-dialog></copy-valuation-portfolio-dialog>
</div>
